<template>
  <div class="admin" :style="'--highlight-color: '+ company.highlight +';'">
    <div class="container" v-if="!user.superadmin">
      <div class="center-everything">
        <p>Ei pääsyä.</p>
      </div>
    </div>
    <div class="container" v-else>
      <div class="row">
        <div class="column column__md">
          <add-company />
        </div>
        <div class="column column__md">
          <add-user />
        </div>
      </div>
      <div class="row">
        <div class="column column__lg">
          <companies />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import AddCompany from "@/components/AddCompany";
import AddUser from "@/components/AddUser";
import Companies from "@/components/Companies";

export default {
  components: {
    AddCompany,
    AddUser,
    Companies,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["user", "company", "userIsAdmin"]),
  },
};
</script>

<style lang="scss">
.admin {
  position: relative;
  width: 100%;
  h3 {
    color: $lightred;
    text-align: center;
  }
}
</style>
